import React from 'react';

import { ActionIcon } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';
import { DroxyDrawer } from 'components/Droxy/DroxyDrawer';
import { useChatMessageHandling } from 'hooks/use-chat-message-handling';
import { AgentIcon } from 'icons/AgentIcon';
import { SmartAssistantPlayground } from 'pages/ManageSmartAssistant/Playground/SmartAssistantPlayground';
import { useTranslation } from 'react-i18next';
import { SmartAssistant } from 'shared/interfaces/SmartAssistant';

interface SmartAssistantPlaygroundDrawerProps {
  smartAssistant: SmartAssistant;
  opened: boolean;
  onClose: () => void;
}

export function SmartAssistantPlaygroundDrawer({
  smartAssistant,
  opened,
  onClose
}: SmartAssistantPlaygroundDrawerProps) {
  const { t } = useTranslation();
  const chatHandling = useChatMessageHandling({ smartAssistant, type: 'DEFAULT' });

  const handleClose = () => {
    chatHandling.setNewConversation();
    onClose();
  };

  return (
    <DroxyDrawer
      opened={opened}
      onClose={handleClose}
      title={t('PLAYGROUND.SMART_ASSISTANT.TITLE')}
      description={t('PLAYGROUND.SMART_ASSISTANT.SUBTITLE')}
      icon={<AgentIcon w={25} h={25} />}
      additionalControls={
        <ActionIcon variant="subtle" onClick={chatHandling.setNewConversation}>
          <IconRefresh />
        </ActionIcon>
      }>
      <SmartAssistantPlayground smartAssistant={smartAssistant} chatHandling={chatHandling} />
    </DroxyDrawer>
  );
}
